(function ($) {
  const initializeBlock = function ($block) {
    $('.team-member__detail__cta').click(function(event) {
      event.preventDefault()
      event.stopPropagation()
      var target = $(this).attr('data-target');console.log('target')

      $('.overlayContainer[data-target="' + target + '"]').addClass('active')
      $('body').addClass('u-noScroll')
    });

    $('.overlay.overlay--team, .overlayContainer-close').click(function(event) {
      var target = $(this).closest('.overlayContainer').attr('data-target');

      $('.overlayContainer[data-target="' + target + '"]').removeClass('active')
      $('body').removeClass('u-noScroll')
    });
  };

  $(document).ready(function () {
    $(".block--team").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction("render_block_preview/type=team", initializeBlock);
  }
})(jQuery);
